<template>
    <div class="section1">
        <div class="play" @click="openvideo"></div>
        <div class="yq" @click="showYq">
            <img :src="require(`../../assets/${language}/1-1/yq.png`)" alt="">
        </div>
        <div class="links">
            <a :class="['a1','wap',language]" href="https://chuang-games.com/recharge/133?regionId=33" target="_blank">{{ i18n('czyh') }}</a>
            <!-- <a class="a1 wap" href="javascript:;" @click="$emit('ljyy')" :style="{'backgroundImage': `url(${require(`../../assets/wap/${language}/1-1/ljyy.png`)})`}"></a> -->
            <a class="a2" id="appStore" href="https://cgatw.onelink.me/8i1Z/dljwb23r" target="_blank" :style="{'backgroundImage': `url(${require(`../../assets/${language}/1-1/appstore.png`)})`}" @click="AddToWishlist"></a>
            <a class="a3" id="googlePlay" href="https://cgatw.onelink.me/8i1Z/dljwb23r" target="_blank" :style="{'backgroundImage': `url(${require(`../../assets/${language}/1-1/googleplay.png`)})`}" @click="AddToWishlist"></a>
        </div>
        <a class="czfl" href="javascript:;" :style="{'backgroundImage': `url(${require(`../../assets/${language}/1-1/czfl.png`)})`}" @click="$emit('openFlLogin')"></a>
    </div>
</template>
<script>
export default {
    props: ['language','i18n'],    
    data() {
        return {
            active: false
        }
    },
    methods: {
        openvideo() {
            this.$emit('openvideo');
        },
        showYq() {
            this.$emit('showYq');
        },
        AddToWishlist() {
            fbq('track', 'AddToWishlist');
            ttq.track('AddToWishlist')
            dataLayer.push({'event': 'button1-click'});
        }
    }
}
</script>
<style lang="less" scoped>
.section1 {
    width: 100%;
    height: 100%;
    background: url('../../assets/zh/1-1/pv.png') center center / cover no-repeat;
    position: relative;
    .play {
        z-index: 10;
        position: absolute;
        top: 50%;
        left: 49%;
        transform: translate(-50%,-50%);
        width: 1.04rem;
        height: 1.04rem;
        background: url(../../assets/zh/1-1/play.png) .45rem center / .29rem .53rem no-repeat;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(../../assets/zh/1-1/play_bg.png) 0 0 / 100% 100% no-repeat;
            animation: circle 3s linear infinite;
        }
        &:active {
            transform: translate(-50%,-50%) scale(0.98);
        }
    }
    .yq {
        position: absolute;
        left: .5rem;
        bottom: 10%;
        width: 3rem;
        height: 2.89rem;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        animation: breath 1.2s linear infinite;

        img {
            width: 2.4rem;
            height: auto;
        }

    }
    .links {
        position: absolute;
        left: 48%;
        transform: translateX(-50%) scale(1.2);
        bottom: 20%;
        display: flex;
        align-items: center;
        a {
            width: 1.83rem;
            height: .63rem;
            margin-left: .18rem;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            &:active {
                transform: scale(0.98);
            }
            &.a1 {
                padding: 0 0.3rem;
                min-width: 2.75rem;
                width: auto;
                height: .68rem;
                line-height: .66rem;
                background-image: url(../../assets/zh/1-1/yy_bg.png);
                text-align: center;
                font-size: .3rem;
                font-weight: bold;
                color: #B04B30;
                transform: translateY(-0.04rem);
            }
            &.a3 {
                width: 2.2rem;
            }
        }
    }
    .czfl {
        position: absolute;
        right: .5rem;
        bottom: 10%;
        display: block;
        width: 2.57rem;
        height: 3.04rem;
        background-position: 0 0;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        animation: breath 1.2s linear infinite;
    }
}
@keyframes breath {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes circle {
    0%{
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
@media screen and (max-width: 751px) {
    .section1 {
        background: url('../../assets/wap/zh/1-1/pv.png') center center / cover no-repeat;
        .play {
            top: 49%;
        }
        .yq {
            width: 2rem;
            height: 2rem;
            left: .4rem;
            top: 1.8rem;
            img {
                width: 2rem;
            }
        }
        .czfl {
            right: unset;
            bottom: unset;
            left: 0;
            top: 4rem;
            transform: scale(0.6);
        }
        .links {
            right: unset;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            width: 6rem;
            height: 22%;
            justify-content: center;
            flex-wrap: wrap;
            justify-content: center;
            a {
                width: 2.4rem;
                height: .78rem;
                margin-left: 0;
                &.a3 {
                    width: 2.8rem;
                    margin-left: .3rem;
                }
            }
            .a1 {
                &.wap {
                    width: 4.2rem;
                    height: .7rem;
                    background-position: 0 0;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-image: url(../../assets/wap/zh/1-1/ljyy.png);
                }
            }
            
        }
    }
}
</style>
